import { render, staticRenderFns } from "./Add_Problem_presentation.vue?vue&type=template&id=be763046"
import script from "./Add_Problem_presentation.vue?vue&type=script&lang=js"
export * from "./Add_Problem_presentation.vue?vue&type=script&lang=js"
import style0 from "./Add_Problem_presentation.vue?vue&type=style&index=0&id=be763046&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports